import React from "react";


const ContactUsPage = () => {
    return (
        <div className="container">
            <h2 className="ml-3">Contact us page</h2>
        </div>
    );
};


export default ContactUsPage;